<template>
  <div ref="popup" class="popup" :class="classes">
    <slot></slot>
  </div>
</template>

<script>
  import isEscapeKey from '@/utils/isEscapeKey';
  import {disableScroll, enableScroll} from '@/utils/scroll';

  export default {
    name: 'BasePopup',

    props: {
      position: {
        type: [String, Boolean],
        default: 'center',
        validator: (v) => [false, 'center'].indexOf(v) !== -1,
      },
      fixed: Boolean,
      preventScroll: Boolean,
    },

    computed: {
      classes() {
        return [this.position && this.position, {fixed: this.fixed}];
      },
    },

    mounted() {
      this.open();
    },

    activated() {
      this.open();
    },

    deactivated() {
      this.close();
    },

    destroyed() {
      this.close();
    },

    methods: {
      open() {
        document.addEventListener('keydown', this.handleDocumentKeydown);

        if (this.fixed) {
          document.addEventListener('click', this.handleDocumentClick);
          document.body.classList.add('popup-visible');
        }

        if (this.fixed || this.preventScroll) {
          disableScroll({disableEvents: true});
        }
      },
      close() {
        document.removeEventListener('keydown', this.handleDocumentKeydown);

        if (this.fixed) {
          document.removeEventListener('click', this.handleDocumentClick);
          document.body.classList.remove('popup-visible');
        }

        if (this.fixed || this.preventScroll) {
          enableScroll();
        }
      },
      isClickOutside(target) {
        return target.contains(this.$refs.popup) && target !== this.$refs.popup;
      },
      handleDocumentClick(event) {
        if (this.isClickOutside(event.target)) {
          this.close();
          this.$emit('close');
        }
      },
      handleDocumentKeydown(event) {
        if (isEscapeKey(event)) {
          this.close();
          this.$emit('close');
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .popup {
    &.center {
      position: absolute;
      z-index: 7;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    &.right-top {
      position: absolute;
      z-index: 11;
      top: 0;
      right: 0;
    }

    &.fixed {
      position: fixed;
      z-index: 11;

      pointer-events: all;
      box-shadow: 0 0 rem(99999px) rem(99999px) rgba(0, 0, 0, 0.25);
    }
  }
</style>
